interface EasykitRefreshButtonProps {
  onClick: () => void;
  loading: boolean;
  /** Extra Tailwind classes (e.g. `ml-auto shrink-0` for the mobile row). */
  className?: string;
}

/** Reusable refresh button + spinning icon (shared between desktop and mobile EK header rows). */
export function EasykitRefreshButton({ onClick, loading, className = '' }: EasykitRefreshButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className={`p-1.5 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 ${className}`.trim()}
      aria-label="Vernieuwen"
    >
      <svg
        className={`w-4 h-4 text-td-navy ${loading ? 'animate-spin' : ''}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
    </button>
  );
}
